module.exports = __webpack_public_path__ + "img/precisely.adf60169.png";